module.exports = __webpack_public_path__ + "img/logo_dhl.1df9ee7b.png";